
import type { MenuItem } from "./types";
import { mainSections } from "./sections/mainSections";
import { employeeSection } from "./sections/employeeSection";
import { clientsSection } from "./sections/clientsSection";
import { locationSection } from "./sections/locationSection";
import { flightSection } from "./sections/flightSection";
import { transportationSection } from "./sections/transportationSection";
import { visaSection } from "./sections/visaSection";
import { servicesSection } from "./sections/servicesSection";
import { workToolsSection } from "./sections/workToolsSection";
import { systemSecuritySection } from "./sections/systemSecuritySection";
import { analyticsSections } from "./sections/analyticsSections";
import { developmentSection } from "./sections/developmentSection";
import { standaloneSections } from "./sections/standaloneSections";
import { inclusionsSection } from "./sections/inclusionsSection";
import { FileText, Bell, User, Activity, Shield, Settings, BarChart3, Ship, Anchor, Palette, Package } from 'lucide-react';

export type { MenuItem };

const pdfTemplateSettingsItem: MenuItem = {
  title: "نماذج PDF",
  href: "/pdf-template-settings",
  icon: FileText,
  color: "from-indigo-500 to-purple-600",
  permission: "الإعدادات",
};

const notificationsItem: MenuItem = {
  title: "الإشعارات",
  href: "/notifications",
  icon: Bell,
  color: "from-blue-500 to-blue-600",
  permission: "الإشعارات",
};

const employeeProfileItem: MenuItem = {
  title: "ملف الموظف",
  href: "/employee-profile",
  icon: User,
  color: "from-purple-500 to-purple-600",
  permission: "الملف الشخصي",
};

const myProfileItem: MenuItem = {
  title: "ملفي الشخصي",
  href: "/my-profile",
  icon: User,
  color: "from-green-500 to-green-600",
  permission: "عرض الملف الشخصي",
};

const systemHealthItem: MenuItem = {
  title: "فحص صحة النظام",
  href: "/system-health",
  icon: Activity,
  color: "from-green-500 to-green-600",
  permission: "فحص صحة النظام",
};

const systemMonitoringItem: MenuItem = {
  title: "مراقبة النظام",
  href: "/system-monitoring",
  icon: Activity,
  color: "from-blue-500 to-indigo-600",
  permission: "مراقبة الأداء",
};


const permissionsItem: MenuItem = {
  title: "إدارة الصلاحيات",
  href: "/permissions",
  icon: Shield,
  color: "from-orange-500 to-red-600",
  permission: "الصلاحيات",
};

const employeeAnalyticsItem: MenuItem = {
  title: "تحليلات الأداء",
  href: "/employee-analytics",
  icon: BarChart3,
  color: "from-indigo-500 to-purple-600",
  permission: "تحليلات الموظفين",
};

// مجموعة البرامج السياحية
const tourismProgramsSection: MenuItem = {
  title: "البرامج السياحية",
  href: "#",
  icon: mainSections[4].icon,
  color: "from-emerald-500 to-emerald-600",
  subItems: [
    mainSections[4], // إنشاء باقة
    mainSections[5], // الباقات السياحية
    mainSections[6], // البحث عن الباقات
  ]
};

// مجموعة إدارة البرامج
const tourismManagementSection: MenuItem = {
  title: "إدارة البرامج",
  href: "#",
  icon: flightSection.icon,
  color: "from-blue-500 to-indigo-600",
  subItems: [
    flightSection, // الرحلات الجوية
    mainSections[3], // الفنادق
    transportationSection, // المواصلات
    locationSection, // الدول
    servicesSection, // الخدمات
    inclusionsSection, // شمول
    {
      title: "لوحات استقبال العلماء",
      href: "/customer-reception-boards",
      icon: Palette,
      color: "from-pink-500 to-rose-600",
      permission: "لوحات استقبال العلماء",
    },
    {
      title: "الرحلات البحرية",
      href: "#",
      icon: Ship,
      color: "from-teal-500 to-cyan-600",
      permission: "الرحلات البحرية",
      subItems: [
        {
          title: "شركات النقل البحري",
          href: "/shipping-companies",
          icon: Ship,
          color: "from-teal-500 to-teal-600",
          permission: "شركات النقل البحري",
        },
        {
          title: "الموانئ",
          href: "/ports",
          icon: Anchor,
          color: "from-cyan-500 to-cyan-600",
          permission: "الموانئ",
        }
      ]
    }
  ]
};

// تم حذف عناصر البصمة

// مجموعة الموارد البشرية
const humanResourcesSection: MenuItem = {
  title: "الموارد البشرية",
  href: "#",
  icon: employeeSection.icon,
  color: "from-purple-500 to-purple-600",
  subItems: [
    {
      title: "الموظفين",
      href: "/employees",
      icon: employeeSection.icon,
      color: "from-purple-500 to-purple-600",
    },
    {
      title: "العهد",
      href: "#",
      icon: Package,
      color: "from-indigo-500 to-indigo-600",
      subItems: [
        {
          title: "إدارة العهد",
          href: "/assets",
          icon: Package,
          color: "from-indigo-500 to-indigo-600",
        },
        {
          title: "تصنيفات العهد",
          href: "/asset-categories",
          icon: Package,
          color: "from-indigo-500 to-indigo-600",
        },
        {
          title: "عهد الموظفين",
          href: "/employee-assets",
          icon: Package,
          color: "from-indigo-500 to-indigo-600",
        }
      ]
    },
    employeeProfileItem, // ملف الموظف
    employeeAnalyticsItem, // تحليلات الأداء
  ]
};

export const menuItems: MenuItem[] = [
  {
    ...mainSections[0], // الرئيسية
    permission: 'الرئيسية'
  },
  myProfileItem, // ملفي الشخصي
  {
    ...clientsSection, // العملاء (مع الأقسام الفرعية)
    permission: 'العملاء'
  },
  {
    ...tourismProgramsSection, // البرامج السياحية
    permission: 'الباقات السياحية'
  },
  {
    ...tourismManagementSection, // إدارة البرامج
    permission: 'الفنادق'
  },
  {
    ...mainSections[2], // الموردين
    permission: 'الموردون'
  },
  {
    ...visaSection, // التأشيرات
    permission: 'التأشيرات'
  },
  {
    ...humanResourcesSection, // الموارد البشرية
    permission: 'الموظفين'
  },
  {
    ...pdfTemplateSettingsItem, // نماذج PDF
    permission: 'إعدادات نماذج PDF'
  },
  {
    ...notificationsItem, // الإشعارات
    permission: 'الإشعارات'
  },
  {
    ...permissionsItem, // إدارة الصلاحيات
    permission: 'إدارة الصلاحيات'
  },
  {
    ...analyticsSections, // التحليل
    permission: 'تحليلات الذكاء الاصطناعي'
  },
  {
    ...systemSecuritySection, // أمان النظام
    permission: 'فحص صحة النظام'
  },
  {
    ...standaloneSections[2], // الإعدادات
    permission: 'الإعدادات'
  },
  {
    ...workToolsSection, // أدوات العمل
    permission: 'سجل الجلسات'
  },
  {
    ...developmentSection, // تحت التطوير
    permission: 'تحت التطوير'
  }
];
